<template>
    <div>

        <config-main-title>
            Fila de {{ titulo }}
        </config-main-title>

        <template v-if="edicao_painel">
            <div class="alert alert-info d-flex justify-content-between">
                <div>Painel | {{ edicao_painel.search }}</div>
                <div>
                    <a href="#" class="card-link" @click="edicao_painel = null">
                        <i class="fa-solid fa-chevron-left"></i>
                    </a>
                </div>
            </div>

            <ul class="list-group mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(painel, ipx) in edicao_painel.paineis" :key="ipx">
                    <div>
                        <a href="#" class="card-link" @click.prevent="editar_painel(painel)">
                            {{ painel.search }}
                        </a>
                        <span class="badge badge-secondary ml-2">
                            #{{ painel.id_fila_laudo_painel }}
                        </span>
                    </div>
                    <div>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + ipx" 
                                v-model="painel.fl_ativo" 
                                @change="toggle_painel(painel)">
                            <label class="custom-control-label" :for="'ativo-' + ipx"></label>
                        </div>
                    </div>
                </li>
            </ul>

            <button type="button" class="btn btn-outline-primary" @click="incluir_painel()">
                <i class="fa-solid fa-plus"></i>
            </button>
        </template>

        <template v-else>

            <div v-if="!em_edicao">

                <div class="row mb-3">
                    <div class="col col-12 col-md-6 d-flex flex-column">
                        <az-input icon="fas fa-search" v-model="search" />
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'A'">
                                Ativos
                            </button>
                            <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'T'">
                                Todos
                            </button>
                        </div>
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <button type="button" class="btn btn-outline-success" @click="incluir ()">
                            Incluir Fila
                        </button>
                    </div>
                </div>

            </div>

            <div v-if="( !lista || !lista.length )">
                <az-empty-state 
                    :msg="'Nenhuma fila identificada.'" 
                    icon="fas fa-search"
                    :action="'Incluir Fila'" 
                    :method="incluir" />
            </div>

            <div v-if="!em_edicao && lista && lista.length">

                <div class="list-group mb-3 az-anime-surgir mb-3">
                    <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                        <span>
                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                                {{ dado.search }}
                            </a>

                            <span class="badge badge-secondary ml-2" title="Id">
                                #{{ dado.id_fila_laudo }}
                            </span>

                            <span class="badge badge-secondary ml-2" v-if="dado.in_ordem_atend" title="Ordem de Atendimento">
                                <i class="fa-solid fa-sort"></i>
                                {{ dado.in_ordem_atend }}
                            </span>
                        </span>
                        <span>
                            <template v-if="viewMode == 'A'">
                                <button type="button" class="btn btn-sm btn-outline-secondary" @click="acessos(dado)">
                                    <i class="fas fa-user-lock mr-2"></i>
                                    {{ dado.acessos.length }}
                                </button>
                                <button type="button" class="btn btn-sm btn-outline-primary ml-1" @click="editar_paineis(dado)" v-if="fila_enferm" title="Paienl de Execução (Centro Cirúrgico)">
                                    <i class="fa-solid fa-tv"></i>
                                    <span v-if="dado.paineis_count" class="ml-2">{{ dado.paineis_count }}</span>
                                </button>
                            </template>
                            
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                        </span>
                    </li>
                </div>

            </div>

        </template>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_fila_laudo ? '' : 'Nova' }}
                            Fila
                            <span v-if="item.id_fila_laudo" class="ml-2">
                                #{{ item.id_fila_laudo }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12" :class="item.fl_fila_procedimento ? 'col-md-9' : 'col-md-12'">
                                <az-input
                                    placeholder="Informe o título da fila..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_fila_laudo" />
                            </div>
                        
                            <template v-if=" item.fl_fila_procedimento">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Ordem de Atendimento"
                                        placeholder="Chamada..."
                                        :validate="validate"
                                        v-model="item.in_ordem_atend" />
                                </div>
                            </template>
                        </div>


                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <template v-if=" !item.fl_fila_enfermagem && !item.fl_fila_vacina ">
                            <div class="form-row mt-2">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="checkbox-group"
                                        sizing="sm"
                                        label="Permitir Alterar o Médico Executante"
                                        :validate="validate"
                                        v-model="item.fl_permitir_alterar_medico" />
                                </div>

                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="checkbox-group"
                                        sizing="sm"
                                        label='Visualizar apenas "Meus Exames"'
                                        :validate="validate"
                                        v-model="item.fl_meus" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="checkbox-group"
                                        sizing="sm"
                                        label="Anatomia Patológica"
                                        :validate="validate"
                                        v-model="item.fl_anat_pat" />
                                </div>
                            </div>
                        </template>

                        <template v-if=" item.fl_fila_procedimento">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        type="checkbox-group"
                                        sizing="sm"
                                        label="Executar Ação Individualmente (Quando tiver mais de um procedimento para o mesmo paciente na fila)"
                                        :validate="validate"
                                        v-model="item.fl_acao_individual" />
                                </div>
                            </div>
                        </template>


                        <!-- Apenas para fila de laudo -->
                        <template v-if=" !item.fl_fila_enfermagem && !item.fl_fila_vacina ">

                            <div class="row" v-if="!fila_proced">
                                <div class="col col-12">
                                    <az-input
                                        label="Próximo Status Padrão"
                                        type="select"
                                        optionsMode="aql"
                                        service="status_laudos.index"
                                        optionsData="id_status_laudo"
                                        :validate="validate"
                                        v-model="item.id_status_laudo_proximo" />
                                </div>
                            </div>

                            <az-sub-title title="Outros Status Subsequentes Possíveis" />
                            <div class="form-row">
                                <div class="col col-12 col-md-3" v-for="(status, isx) in item.lista_status" :key="isx">
                                    <div class="input-group input-group-sm mb-3">
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_status(isx)">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                        <label class="form-control">
                                            {{ status.search }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        icon="fa fa-plus"
                                        type="select"
                                        optionsMode="aql"
                                        service="status_laudos.index"
                                        v-model="status_para_incluir"
                                        @input="add_status()" /> 
                                </div>
                            </div>

                        </template>

                        <div class="form-row" v-if="!item.fl_fila_vacina">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    :edicao="!item.fl_pos_atendimento && !item.fl_pre_atendimento"
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Fila Paralela"
                                    v-model="item.fl_fila_paralela" />
                            </div>
                            <div class="col col-12 col-md-6" v-if="item.fl_fila_paralela && !item.fl_pos_atendimento && !item.fl_pre_atendimento">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Não ocupar paciente durante atendimento"
                                    v-model="item.fl_fila_paralela_nao_ocupar" />
                            </div>
                        </div>

                        <!-- Modelos -->
                        <template v-if="item.fl_fila_enfermagem">
                            <div class="form-row mb-3">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        placeholder="Sem Filtro"
                                        label="Consultas"
                                        type="select"
                                        :optionsList="[
                                            {id: 'I', search: 'Consultas Iniciais'},
                                            {id: 'S', search: 'Consultas Subsequentes'},
                                            {id: 'C', search: 'Consultas Iniciais/Subsequentes'},
                                            {id: 'R', search: 'Consultas de Revisão'},
                                        ]"
                                        optionsData="id"
                                        :validate="validate"
                                        v-model="item.ch_tipo_consulta" />
                                </div>
                            </div>

                            <div class="alert alert-info small p-2" v-if="fila_enferm && item.fl_fila_paralela">
                                Deve ser utilizada quando a chamada e finalização da fila não encerra o atendimento do paciente. (Ex.: Atendimento pela enfermagem ou anestesista em paralelo ao atendimento do cirurgião).

                                <div class="mt-2" v-if="fila_enferm && item.fl_fila_paralela && item.fl_fila_paralela_nao_ocupar">
                                    Ao marcar para não ocupar o paciente durante o atendimento, outras filas poderão chamar o paciente, mesmo estando em atendimento nessa fila.
                                </div>
                            </div>

                            <template v-else>

                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input
                                            :edicao="!item.fl_pos_atendimento"
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Fila de Pré-Atendimento"
                                            v-model="item.fl_pre_atendimento" />
                                    </div>
                                </div>
                                <div class="form-row" v-if="item.fl_pre_atendimento">
                                    <div class="col col-12">
                                        <az-input
                                            :edicao="!item.fl_pos_atendimento"
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Exibir Status do Consultório na Fila"
                                            v-model="item.fl_show_status_consult" />
                                    </div>
                                </div>

                            </template>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Centro Cirúrgico"
                                        v-model="item.fl_cc" />
                                </div>
                            </div>
                        </template>

                        <template v-if="( item.fl_fila_enfermagem || item.fl_fila_procedimento ) && ( !item.fl_pre_atendimento && !item.fl_fila_paralela )">
                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fila de Pós-Atendimento da Consulta"
                                        v-model="item.fl_pos_atendimento" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        v-if="item.fl_pos_atendimento"
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Exibir anotações do atendimento na assistência"
                                        v-model="item.fl_assist_exibir_pep" />
                                </div>
                            </div>
                        </template>

                        <template v-if="( item.fl_fila_enfermagem && !item.fl_pre_atendimento )">
                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Apenas paciente com prescrição médica"
                                        v-model="item.fl_com_presc" />
                                </div>
                            </div>
                        </template>

                        <template v-if="( item.fl_fila_enfermagem && !item.fl_pre_atendimento )">
                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Não trocar médico executante ao chamar"
                                        v-model="item.fl_block_trocar_medico" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Baseada na Data de Internação do Paciente"
                                        v-model="item.fl_fila_intern" />
                                </div>
                            </div>
                        </template>

                        <!-- Modelos -->
                        <template v-if="( item.fl_fila_enfermagem || item.fl_fila_vacina ) && item.modelos && !item.fl_pre_atendimento">
                            <az-sub-title class="mt-3" title="Formulários" />
                            <div class="form-row" v-for="(modelo, imx) in lista_modelos" :key="imx">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        v-if="modelo && modelo.modelo"
                                        sizing="sm"
                                        :edicao="false" 
                                        v-model="modelo.modelo.st_modelo_prontuario">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="modelo.fl_ativo = false">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input  
                                        sizing="sm"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="[
                                            { id: 'T', search: 'Todos' },
                                            { id: 'M', search: 'Médico' },
                                            { id: 'N', search: 'Não Médico' },
                                        ]"
                                        optionsData="id"
                                        v-model="modelo.ch_acesso" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input  
                                        label="Ordem"
                                        :compact="true"
                                        sizing="sm"
                                        type="number"
                                        v-model="modelo.in_regra_ordem" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input  
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Fixo" 
                                        v-model="modelo.fl_fixo" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input  
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Lista" 
                                        v-model="modelo.fl_lista" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        icon="fa fa-plus"
                                        type="select"
                                        optionsMode="aql"
                                        :optionsParm="{ ativos: 1 }"
                                        service="modelos.index"
                                        v-model="novo_modelo"
                                        @input="incluir_modelo()" /> 
                                </div>
                            </div>
                        </template>

                        <!-- Filtros -->
                        <filtro-model class="mt-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <br><br><br><br><br>
                        
                        <pre v-if="1==0">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="filaLaudo" :id="item.id_fila_laudo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_fila_laudo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edição Painel -->
        <div class="modal fade" id="edicaoPainelModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item_painel">
                    <div class="modal-header">
                        <h5 class="modal-title">Painel</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Nome"
                                    :validate="validate"
                                    required
                                    v-model="item_painel.st_nome" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Ordem"
                                    type="number"
                                    v-model="item_painel.in_ordem" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Tipo de Arquivo"
                                    type="select"
                                    optionsMode="aql"
                                    service="tipo_arquivos.index"
                                    optionsData="id_tipo_arquivo"
                                    v-model="item_painel.id_tipo_arquivo" />
                            </div>
                        </div>

                        <az-sub-title title="Campos do Painel" class="mt-3" />
                        <div class="form-row" v-for="(campo, icx) in item_painel.js_campos" :key="icx">
                            <div class="col col-12 col-md-5">
                                <az-input
                                    sizing="sm"
                                    placeholder="Id..."
                                    required
                                    :validate="validate"
                                    v-model="campo.id">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_campo(item_painel, icx)">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-5">
                                <az-input
                                    sizing="sm"
                                    placeholder="Título..."
                                    required
                                    :validate="validate"
                                    v-model="campo.titulo">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    placeholder="Ordem..."
                                    required
                                    :validate="validate"
                                    v-model="campo.ordem">
                                </az-input>
                            </div>
                        </div>

                        <button type="button" class="btn btn-sm btn-outline-primary mt-3" @click="incluir_campo()">
                            <i class="fa-solid fa-plus"></i>
                        </button>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_painel ()">{{ item_painel.id_fila_laudo_painel ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
            fila_proced: false, 
            fila_enferm: false, 
            fila_vacina: false,
            novo_modelo: "", 
            edicao_painel: null, 
            item_painel: null, 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel,
        AzSubTitle, 
        EdicaoAcessos,
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'tag-procedimento', search:'Classificação do Procedimento', service: 'procedimentos.index', parms: { ativos: true }, tag: true}, 
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\sinalizadorAtendimento', search:'Sinalizador de Atendimento', service: 'sinalizadores.index', parms: { ativos: 1 }},
                {id:'App\\azure\\statusLaudo', search:'Status do Laudo', service: 'status_laudos.index'},
            ];
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }
            
            return _.orderBy(opcoes, 'search');
        },

        titulo: function () {
            if ( this.fila_enferm ) 
                return 'Assistência';

            if ( this.fila_vacina ) 
                return 'Vacina';

            if ( this.fila_proced )
                return 'Procedimento';

            return 'Laudo';
        },

        lista_modelos: function () { 
            if ( !this.item )
                return [];

            return this.item.modelos.filter(modelo => modelo.fl_ativo);
        }
    },

    methods: { 
        atualizar_painel () { 
            this.$util.atualizar(this, { 
                service: 'fila_laudo_paineis',
                dados: this.item_painel,
                callback: () => { 
                    this.editar_paineis(this.edicao_painel);
                },
                modal: 'edicaoPainelModal',
            });
        },

        incluir_campo() { 
            if ( !this.item_painel.js_campos ) { 
                this.item_painel.js_campos = [];
            }

            this.item_painel.js_campos.push({ 
                id: "", 
                titulo: "", 
                ordem: 100, 
            });
        },

        remover_campo(item_painel, index) { 
            item_painel.js_campos.splice(index, 1);
        },

        editar_painel(painel) { 
            this.item_painel = _.cloneDeep(painel);
            this.validate = false; 
            $('#edicaoPainelModal').modal('show');
        },

        incluir_painel() { 
            this.validate = false; 
            this.item_painel = {
                id_fila_laudo_painel: null, 
                id_fila_laudo: this.edicao_painel.id_fila_laudo, 
                st_nome: "",
                in_ordem: 100,
                id_tipo_arquivo: "", 
                fl_ativo: true,
                js_campos: [],
            };

            $('#edicaoPainelModal').modal('show');
        },

        editar_paineis (item) { 
            item.paineis = []; 
            this.edicao_painel = _.cloneDeep(item); 

            this.$util.load(this, { 
                service: 'fila_laudo_paineis',
                func: 'index',
                parms: { 
                    id_fila_laudo: item.id_fila_laudo,
                },
                loadTo: res => { 
                    this.edicao_painel.paineis = res;
                }
            });
        }, 

        incluir_modelo() { 
            if ( this.novo_modelo ) { 
                this.item.modelos.push({
                    id_fila_laudo_modelo: null, 
                    id_modelo_prontuario: this.novo_modelo.id_modelo_prontuario,
                    modelo: this.novo_modelo, 
                    id_fila_laudo: this.item.id_fila_laudo, 
                    in_regra_ordem: 100, 
                    fl_ativo: true, 
                    fl_fixo: false,
                    fl_lista: false, 
                    ch_acesso: "", 
                });

                this.novo_modelo = "";

                this.$nextTick(() => { 
                    this.novo_modelo = null;
                });
            }
        },

        acessos(item) { 
          this.$refs.acessos.abrir('App\\azure\\filaLaudo', item.id_fila_laudo);
        },
        remover_status (index) { 
            this.item.lista_status.splice(index,1);
        },

        add_status () { 
            if ( !this.status_para_incluir )
                return;

            if ( this.item.lista_status.findIndex(item => item.id_status_laudo == this.status_para_incluir.id_status_laudo) < 0 ) { 
                this.item.lista_status.push(this.status_para_incluir);
            }

            this.$nextTick(() => { 
                this.status_para_incluir = "";
            });
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },
        incluir_filtro(item) { 
            item.filtros.push({ 
                id_fila_laudo_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },
        incluir () { 
            this.validate = false;

            let item = {
                st_titulo: "", 
                fl_ativo: true,
                st_fila_laudo: "", 
                st_observacoes: "", 
                fl_fila_procedimento: this.fila_proced,
                fl_fila_enfermagem: this.fila_enferm, 
                fl_fila_vacina: this.fila_vacina,
                fl_permitir_alterar_medico: false, 
                fl_cc: false, 
                filtros: [],
                lista_status: [], 
                modelos: [], 
                ch_tipo_consulta: "", 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'fila_laudos',
                func: 'index',
                parms: { 
                    fila_procedimento: this.fila_proced,
                    enfermagem: this.fila_enferm, 
                    vacina: this.fila_vacina, 
                    todas: false, 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            if ( !this.item.endereco ) { 
                this.item.endereco = { cidade: {} };
            }

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'fila_laudos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'fila_laudos',
                dados: item,
            });

        },

        toggle_painel (item) { 

            this.$util.toggle(this, { 
                service: 'fila_laudo_paineis',
                dados: item,
            });

        },

        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    beforeMount() { 
        if ( this.$route.name == 'c-fila-enferm' ) { 
            this.fila_enferm = true;
        } else if ( this.$route.name == 'c-fila-proced' ) { 
            this.fila_proced = true;
        } else if ( this.$route.name == 'c-fila-vacina' ) { 
            this.fila_vacina = true;
        }
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Fila de " + this.titulo, method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>